import { inject, Injectable } from '@angular/core';
import {
  ServoBikeProductType,
  PublicServoBikeApiService,
  PublicServoBikeContractCreateDto, ProductServoPipelineResultDto, ServoBikeVersicherungspraemieCalcDto, VersicherungspraemieCalculationResultDto
} from '@base/backend';
import { BehaviorSubject, catchError, map, Observable, of, tap } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class BikeService {
  private readonly publicServoBikeApiService = inject(PublicServoBikeApiService);

  /**
   * Servo Bike Prämienberechnung Ergebnis
   */

  public getPremium(
    price: number,
    isEbike: boolean | undefined,
    bikeProductType: ServoBikeProductType
  ): Observable<number | null> {
    const dto: ServoBikeVersicherungspraemieCalcDto = {
      kaufpreisInEur: price,
      isEbike: isEbike,
      bikeProductType: bikeProductType
    };

    return this.calculateBikePraemie(dto).pipe(
      map(calculationResult => calculationResult.versicherungspraemieInEur || null),
      catchError(() => {
        return of(null);
      })
    );
  }

  private bikeCalculationResultSubject = new BehaviorSubject<VersicherungspraemieCalculationResultDto | null>(null);

  calculateBikePraemie(dto: ServoBikeVersicherungspraemieCalcDto): Observable<VersicherungspraemieCalculationResultDto> {
    return this.publicServoBikeApiService
      .apiPublicServoBikeContractBikeVersicherungspraemiePost(dto)
      .pipe(
        tap((result) => this.bikeCalculationResultSubject.next(result))
      );
  }

  getBikeCalculationResult(): VersicherungspraemieCalculationResultDto | null {
    return this.bikeCalculationResultSubject.value;
  }

  submitBikeContract(dto: PublicServoBikeContractCreateDto): Observable<ProductServoPipelineResultDto> {
    return this.publicServoBikeApiService
      .apiPublicServoBikeContractBikePost(dto);
  }
}
